import { Controller } from "@hotwired/stimulus";
import * as VoePay from "../../utils/voe_pay";

// The record-verification dialog: shows the picked contact's emails beside the form, names them in the
// "stated in writing" line, and keeps the annualized-pay readout in step with what the analyst types.
export default class extends Controller {
  static targets = [
    "contact",
    "conversation",
    "attestationName",
    "structure",
    "hoursField",
    "payAmount",
    "payAmountLabel",
    "payAmountError",
    "payHours",
    "payHoursError",
    "payReadout",
    "payFormula",
    "payAnnual",
  ];

  pickContact() {
    const id = this.contactTarget.value;
    this.conversationTargets.forEach((conversation) => {
      conversation.hidden = conversation.dataset.contactId !== id;
    });
    const option = this.contactTarget.selectedOptions[0];
    this.attestationNameTarget.textContent = (id && option.dataset.name) || "the contact";
  }

  toggleHours() {
    const shown = this.structureTarget.value === "hourly";
    this.hoursFieldTarget.hidden = !shown;
    this.hoursFieldTarget.disabled = !shown;
  }

  payFormulaTargetConnected() {
    this.refreshPay();
  }

  refreshPay(event) {
    const structure = this.structureTarget.value || null;
    const amount = VoePay.parseAmount(this.payAmountTarget.value);
    const hours = parseFloat(this.payHoursTarget.value);
    const annual = VoePay.annualize(structure, amount, hours);
    this.payReadoutTarget.hidden = structure === null;
    this.payFormulaTarget.textContent =
      annual === null ? VoePay.promptText(structure) : VoePay.formulaText(structure, amount, hours);
    this.payAnnualTarget.textContent = annual === null ? "" : `${VoePay.currency(annual)} / yr`;
    this.payAmountLabelTarget.textContent = VoePay.amountLabel(structure);
    const typing = event?.type === "input";
    const amountProblem = VoePay.amountProblem(this.payAmountTarget.value);
    const hoursProblem = VoePay.hoursProblem(this.payHoursTarget.value, this.payHoursTarget.validity.badInput);
    VoePay.flag(this.payAmountTarget, this.payAmountErrorTarget, amountProblem, typing);
    VoePay.flag(this.payHoursTarget, this.payHoursErrorTarget, hoursProblem, typing);
  }
}
